import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./MobileHeaderwithCancleFunction.module.css";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
var MobileHeaderwithCancleFunction = function MobileHeaderwithCancleFunction(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("strong", {
    className: "font-bold"
  }, props.title || /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 20,
    divWidth: 200
  })), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return props.buttonFunction();
    }
  }, t("cancel", {
    ns: "web_checkout_cash"
  })), props.showBack && /*#__PURE__*/React.createElement("div", {
    className: stl.backBtn
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrow_right.svg",
    alt: "arrow"
  })));
};
export default MobileHeaderwithCancleFunction;